document.addEventListener('DOMContentLoaded',function(){
    iniciarApp();
})

function iniciarApp(){
    temas();
    menuMovil(); // nueva función
}

function temas(){
    const temas = document.querySelectorAll('.div_curso .tema');
    temas.forEach( boton => {
        boton.addEventListener('click', function(e){
            const id = boton.attributes['data-tema'].value;
            console.log(id);
        });
    });
}

function menuMovil() {
    const btnMenu = document.querySelector('.click_menu_movil');
    const menu = document.getElementById('div_menu_movil');
    const overlay = document.getElementById('div_overlay');

    if (!btnMenu || !menu || !overlay) return;

    btnMenu.addEventListener('click', () => {
        menu.classList.add('menu-abierto');
        menu.classList.remove('oculto');
        overlay.classList.add('overlay-activo');
    });

    overlay.addEventListener('click', () => {
        menu.classList.remove('menu-abierto');
        overlay.classList.remove('overlay-activo');
        menu.classList.add('oculto');
    });
}


function errorMensaje(campo){
    const mensajeError = document.querySelector('#mensajeError');
    mensajeError.textContent = '';
    const p = document.createElement('P');

    // console.log(mensajeError);
    campo.focus();
    campo.classList.add('vacio')
    //console.log('El campo es obligatorio');
    //console.log(campo.placeholder);
    let mensaje = '';
   if (typeof campo.placeholder === 'undefined') {
        mensaje = 'Ingresa: Selecciona una opción';
    } else {
        mensaje = 'Ingresa: '+ campo.placeholder;
    }
    //const mensaje = 'Ingresa: '+ campo.placeholder;
    p.textContent= mensaje;
    //mensajeError.textContent = mensajeError;
    mensajeError.append(p);
    console.log(mensaje);
}
function ValidaEmail(email) {
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
}
